module.exports = __webpack_public_path__ + "img/icon_indicator_blue_3.9d790089.png";